// Desktop for public pages that u can see even while unloginned
// lacks of mobile version
import React from 'react';
import { observer } from 'mobx-react-lite';
import styled from 'styled-components';
import { themeGet } from 'styled-system';

import { useStore } from '@src/models';
import { ROUTES } from 'src/constants';
import { Flex, BaseLink, TextBox } from 'src/kit';
import { Dropdown, LogoTiny, LogoMedium } from 'src/components';
import { composeFullUrl } from 'src/helpers';
import { Avatar } from '../../molecules/Avatar';
import { CompanyActions } from './components/CompanyActions';
import { AuthActions } from './components/AuthActions';

const links = [
  { label: 'Employers', to: ROUTES.home },
  { label: 'Features', to: ROUTES.features },
  { label: 'Candidates', to: ROUTES.candidates },
  { label: 'Articles', to: ROUTES.articles }
];

const candidateFeaturesRoutes = [
  { label: 'Jobs', to: ROUTES.jobs.base },
  { label: 'Explore', to: ROUTES.magazine },
  { label: 'Resource', to: ROUTES.resources },
];

export const DesktopPublicHeader = observer(function DesktopHeader() {
  const {
    routerStore: {
      location: { pathname: fullPathname }
    },
    authStore: { isAuthorized, logout },
    userStore: { user, defaultProfileRoute }
  } = useStore();

  // /jobs/1564 => /jobs
  const truncatedPathname = '/' + fullPathname.split('/')[1];

  return (
    <Wrapper>
      <Flex alignItems="center">
        <BaseLink href={ROUTES.home}>
          <LogoTiny color="#0d2240" height="34px" />
          <LogoMedium color="primary" mr="26px" height="26px" width="96px" />
        </BaseLink>
        {links.map(({ label, to }) => {
          // https://zpl.io/blw5445
          if (
            candidateFeaturesRoutes.find(({ to }) => to === truncatedPathname) &&
            (to === ROUTES.candidates || to === ROUTES.features)
          )
            return false;
          return (
            truncatedPathname !== to && (
              <Flex key={to} height="26px" alignItems="flex-end">
                <BaseLink href={to} mr={30} fontSize="16px" height="16px" color="textSecondary">
                  {label}
                </BaseLink>
              </Flex>
            )
          );
        })}
        <DropdownWrapper>
          <Dropdown.Toggle withCaret>
            <Flex height="26px" alignItems="flex-end">
              <TextBox fontSize="16px" height="16px" color="textSecondary">
                Jobs and resources
              </TextBox>
            </Flex>
          </Dropdown.Toggle>
          <Dropdown.Menu mt={'-10px'} minWidth={150} color="textPrimary">
            {candidateFeaturesRoutes.map(({ label, to }) => (
              <Dropdown.Item key={to}>
                <BaseLink href={composeFullUrl(to)} mr={30} fontSize="14px">
                  {label}
                </BaseLink>
              </Dropdown.Item>
            ))}
          </Dropdown.Menu>
        </DropdownWrapper>
      </Flex>
      <Flex ml="auto" alignItems="center">
        {user?.company && <CompanyActions user={user} />}
        {!isAuthorized ? (
          <AuthActions />
        ) : (
          <Dropdown>
            <Dropdown.Toggle>
              <Avatar
                src={user?.photo_thumbnail_url}
                alt="photo"
                firstName={user?.first_name}
                size={40}
                color="header.text"
                bg="paleGreyTwo"
                fontSize="22px"
                fontWeight="normal"
                lineHeight="38px"
              />
            </Dropdown.Toggle>
            <Dropdown.Menu mt={'-10px'} minWidth={150} color="textSecondary">
              <Dropdown.Item>
                <BaseLink href={defaultProfileRoute}>My profile</BaseLink>
              </Dropdown.Item>
              <Dropdown.Item>
                <TextBox onClick={() => logout()}>Logout</TextBox>
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        )}
      </Flex>
    </Wrapper>
  );
});

export const Wrapper = styled(Flex)`
  align-items: center;
  height: 80px;
  padding: 0 60px;
  border-bottom: 1px solid ${themeGet('colors.iceBlueTwo')};
  position: sticky;
  top: 0;
  z-index: 1000;
  background: white;

  .dropdown-caret {
    color: ${themeGet('colors.textSecondary')};
    align-self: flex-end;
  }
`;

const DropdownWrapper = styled(Dropdown)`
  li {
    padding: 0;
    a {
      padding: 0.5rem 1rem;
      width: 100%;
      margin-right: 0;
    }
  }
`;
